module.exports = __webpack_public_path__ + "static/media/logo_sony.808050d5.png";